const AdminBasePage = () => {
    return (
        <div class="flex h-screen w-full items-center justify-center bg-gray-900 bg-cover bg-no-repeat" styles="background-image:url('https://images.unsplash.com/photo-1499123785106-343e69e68db1?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1748&q=80')">
            <div class="rounded-xl bg-gray-800 bg-opacity-50 px-16 py-10 shadow-lg backdrop-blur-md max-sm:px-8">
                <div class="text-white">
                    <div class="mb-8 flex flex-col items-center">
                        <img src="https://iili.io/Hvw2XV4.pnghttps://www.logo.wine/a/logo/Instagram/Instagram-Glyph-Color-Logo.wine.svg" width="150" alt="" srcset="" />
                        <h1 class="mb-2 text-2xl">Insurego</h1>
                        <span class="text-gray-300">Select the operation</span>
                    </div>
                    <form action="#">
                        <div class="mb-4 text-lg">
                            <a href="/register_ins" class="rounded-3xl border-none bg-yellow-400 bg-opacity-50 px-6 py-2 text-center text-inherit placeholder-slate-200 shadow-lg outline-none backdrop-blur-md"  >Register Insurance </a>
                        </div>

                        <div class="mb-4 text-lg">
                            <a href="/buy_ins" class="rounded-3xl border-none bg-yellow-400 bg-opacity-50 px-6 py-2 text-center text-inherit placeholder-slate-200 shadow-lg outline-none backdrop-blur-md"  >Buy Insurance </a>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default AdminBasePage;